/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PaymentCreateReqVo,
  PaymentNotifyReqVo,
  RefundBillReqVo,
  ResponseAdminPaymentListVo,
  ResponseBoolean,
  ResponsePaymentCreateRespVo,
  ResponsePaymentListVo,
  ResponseUnpaidPaymentVo,
} from '../models/index';
import {
    PaymentCreateReqVoFromJSON,
    PaymentCreateReqVoToJSON,
    PaymentNotifyReqVoFromJSON,
    PaymentNotifyReqVoToJSON,
    RefundBillReqVoFromJSON,
    RefundBillReqVoToJSON,
    ResponseAdminPaymentListVoFromJSON,
    ResponseAdminPaymentListVoToJSON,
    ResponseBooleanFromJSON,
    ResponseBooleanToJSON,
    ResponsePaymentCreateRespVoFromJSON,
    ResponsePaymentCreateRespVoToJSON,
    ResponsePaymentListVoFromJSON,
    ResponsePaymentListVoToJSON,
    ResponseUnpaidPaymentVoFromJSON,
    ResponseUnpaidPaymentVoToJSON,
} from '../models/index';

export interface PaymentAdminListGetRequest {
    currentPage?: number;
    pageSize?: number;
    payType?: number;
    paymentType?: number;
    paymentCode?: string;
    billCode?: string;
    billStatus?: number;
    userName?: string;
    userCode?: string;
    applyDateStart?: string;
    applyDateEnd?: string;
}

export interface PaymentCancelPaymentIdPostRequest {
    paymentId: number;
}

export interface PaymentConfirmPaymentIdPostRequest {
    paymentId: number;
}

export interface PaymentCreatePostRequest {
    paymentCreateReqVo?: PaymentCreateReqVo;
}

export interface PaymentListGetRequest {
    currentPage?: number;
    pageSize?: number;
    userId?: number;
    account?: string;
    billType?: Array<number>;
    billCode?: string;
    orderCode?: string;
}

export interface PaymentNotifyPostRequest {
    paymentNotifyReqVo?: PaymentNotifyReqVo;
}

export interface PaymentRefundPostRequest {
    refundBillReqVo?: RefundBillReqVo;
}

export interface PaymentUnpaidBillListGetRequest {
    userName: string;
    actualPayAmount: string;
}

/**
 * 
 */
export class PaymentControllerApi extends runtime.BaseAPI {

    /**
     * 
     * 管理员分页查询支付单列表
     */
    async paymentAdminListGetRaw(requestParameters: PaymentAdminListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseAdminPaymentListVo>> {
        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['payType'] != null) {
            queryParameters['payType'] = requestParameters['payType'];
        }

        if (requestParameters['paymentType'] != null) {
            queryParameters['paymentType'] = requestParameters['paymentType'];
        }

        if (requestParameters['paymentCode'] != null) {
            queryParameters['paymentCode'] = requestParameters['paymentCode'];
        }

        if (requestParameters['billCode'] != null) {
            queryParameters['billCode'] = requestParameters['billCode'];
        }

        if (requestParameters['billStatus'] != null) {
            queryParameters['billStatus'] = requestParameters['billStatus'];
        }

        if (requestParameters['userName'] != null) {
            queryParameters['userName'] = requestParameters['userName'];
        }

        if (requestParameters['userCode'] != null) {
            queryParameters['userCode'] = requestParameters['userCode'];
        }

        if (requestParameters['applyDateStart'] != null) {
            queryParameters['applyDateStart'] = requestParameters['applyDateStart'];
        }

        if (requestParameters['applyDateEnd'] != null) {
            queryParameters['applyDateEnd'] = requestParameters['applyDateEnd'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payment/admin/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseAdminPaymentListVoFromJSON(jsonValue));
    }

    /**
     * 
     * 管理员分页查询支付单列表
     */
    async paymentAdminListGet(requestParameters: PaymentAdminListGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseAdminPaymentListVo> {
        const response = await this.paymentAdminListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 取消支付
     */
    async paymentCancelPaymentIdPostRaw(requestParameters: PaymentCancelPaymentIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        if (requestParameters['paymentId'] == null) {
            throw new runtime.RequiredError(
                'paymentId',
                'Required parameter "paymentId" was null or undefined when calling paymentCancelPaymentIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payment/cancel/{paymentId}`.replace(`{${"paymentId"}}`, encodeURIComponent(String(requestParameters['paymentId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 
     * 取消支付
     */
    async paymentCancelPaymentIdPost(requestParameters: PaymentCancelPaymentIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.paymentCancelPaymentIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 确认支付
     */
    async paymentConfirmPaymentIdPostRaw(requestParameters: PaymentConfirmPaymentIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        if (requestParameters['paymentId'] == null) {
            throw new runtime.RequiredError(
                'paymentId',
                'Required parameter "paymentId" was null or undefined when calling paymentConfirmPaymentIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payment/confirm/{paymentId}`.replace(`{${"paymentId"}}`, encodeURIComponent(String(requestParameters['paymentId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 
     * 确认支付
     */
    async paymentConfirmPaymentIdPost(requestParameters: PaymentConfirmPaymentIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.paymentConfirmPaymentIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 创建支付记录
     */
    async paymentCreatePostRaw(requestParameters: PaymentCreatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePaymentCreateRespVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payment/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PaymentCreateReqVoToJSON(requestParameters['paymentCreateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePaymentCreateRespVoFromJSON(jsonValue));
    }

    /**
     * 
     * 创建支付记录
     */
    async paymentCreatePost(requestParameters: PaymentCreatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePaymentCreateRespVo> {
        const response = await this.paymentCreatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 分页查询支付单列表
     */
    async paymentListGetRaw(requestParameters: PaymentListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePaymentListVo>> {
        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['account'] != null) {
            queryParameters['account'] = requestParameters['account'];
        }

        if (requestParameters['billType'] != null) {
            queryParameters['billType'] = requestParameters['billType'];
        }

        if (requestParameters['billCode'] != null) {
            queryParameters['billCode'] = requestParameters['billCode'];
        }

        if (requestParameters['orderCode'] != null) {
            queryParameters['orderCode'] = requestParameters['orderCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payment/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePaymentListVoFromJSON(jsonValue));
    }

    /**
     * 
     * 分页查询支付单列表
     */
    async paymentListGet(requestParameters: PaymentListGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePaymentListVo> {
        const response = await this.paymentListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 仅在只用信用卡支付时自动回调
     * 信用卡支付回调（Billgate回调）
     */
    async paymentNotifyPostRaw(requestParameters: PaymentNotifyPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payment/notify`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PaymentNotifyReqVoToJSON(requestParameters['paymentNotifyReqVo']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * 仅在只用信用卡支付时自动回调
     * 信用卡支付回调（Billgate回调）
     */
    async paymentNotifyPost(requestParameters: PaymentNotifyPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.paymentNotifyPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 各类型费用退款
     */
    async paymentRefundPostRaw(requestParameters: PaymentRefundPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payment/refund`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RefundBillReqVoToJSON(requestParameters['refundBillReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 
     * 各类型费用退款
     */
    async paymentRefundPost(requestParameters: PaymentRefundPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.paymentRefundPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 查询关联账单为待确认的支付记录
     */
    async paymentUnpaidBillListGetRaw(requestParameters: PaymentUnpaidBillListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUnpaidPaymentVo>> {
        if (requestParameters['userName'] == null) {
            throw new runtime.RequiredError(
                'userName',
                'Required parameter "userName" was null or undefined when calling paymentUnpaidBillListGet().'
            );
        }

        if (requestParameters['actualPayAmount'] == null) {
            throw new runtime.RequiredError(
                'actualPayAmount',
                'Required parameter "actualPayAmount" was null or undefined when calling paymentUnpaidBillListGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userName'] != null) {
            queryParameters['userName'] = requestParameters['userName'];
        }

        if (requestParameters['actualPayAmount'] != null) {
            queryParameters['actualPayAmount'] = requestParameters['actualPayAmount'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payment/unpaid-bill/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUnpaidPaymentVoFromJSON(jsonValue));
    }

    /**
     * 
     * 查询关联账单为待确认的支付记录
     */
    async paymentUnpaidBillListGet(requestParameters: PaymentUnpaidBillListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUnpaidPaymentVo> {
        const response = await this.paymentUnpaidBillListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
